// extracted by mini-css-extract-plugin
export default {"noDataScreen":"PNr8_SJLFJ"};